import { Col, Row } from "antd";
import UsersSection from "../components/Sections/Users";
import { useUser } from "../context/UserContext";
import { hasRoleAccess } from "../utils/constants";

const Users = () => {
  const { roles } = useUser();

  if (!hasRoleAccess(roles, ["ADMIN", "HR"])) {
    return null;
  }

  return (
    <Row>
      <Col xs={24}>
        <UsersSection />
      </Col>
    </Row>
  );
};

export default Users;
